import ScalarSidebar_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebar.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarSidebar.vue
var ScalarSidebar_default = ScalarSidebar_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebar_default as default };

//# sourceMappingURL=ScalarSidebar.vue.js.map